import { render, staticRenderFns } from "./ArticoloDrawer2.vue?vue&type=template&id=77936580&scoped=true&"
import script from "./ArticoloDrawer2.vue?vue&type=script&lang=js&"
export * from "./ArticoloDrawer2.vue?vue&type=script&lang=js&"
import style0 from "./ArticoloDrawer2.vue?vue&type=style&index=0&id=77936580&css=true&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77936580",
  null
  
)

export default component.exports